<template>
  <div class="exception-logs-box outer-page-primary">
    <div class="header-box title-box">
      <div class="symbol" />
      <div class="title">异常日志</div>
    </div>
    <div class="operation-box">
      <div class="filter-box">
        <div class="filter-item-box">
          <div class="label-box searchLabel">内容检索：</div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              clearable
              placeholder="请输入相关关键字"
              v-model="keywords" />
          </div>
        </div>
        <div class="filter-item-box">
          <div class="label-box searchLabel">异常业务类型：</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              clearable
              v-model="errorBusinessType"
              :popper-append-to-body="false"
              placeholder="请选择异常业务类型">
              <el-option
                value="Upload"
                label="文件上传" />
              <el-option
                value="Download"
                label="下载" />
              <el-option
                value="Convert"
                label="转换异常" />
              <el-option
                value="Commercialize"
                label="商业化授权" />
              <el-option
                value="SysInitialize"
                label="初始化" />
              <el-option
                value="Other"
                label="其他异常" />
            </el-select>
          </div>
        </div>
        <div class="filter-item-box">
          <div class="label-box searchLabel">异常源类型：</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              clearable
              v-model="errorSourceType"
              :popper-append-to-body="false"
              placeholder="请选择异常源类型">
              <el-option
                value="InvalidConfigenation"
                label="配置错误" />
              <el-option
                value="InvalidParameter"
                label="参数错误" />
              <el-option
                value="InvalidCommercialize"
                label="商业化授权错误" />
              <el-option
                value="InvalidOperation"
                label="操作错误" />
              <el-option
                value="InvalidAuthorization"
                label="权限错误" />
              <el-option
                value="DbError"
                label="数据库错误" />
              <el-option
                value="Other"
                label="其他异常" />
            </el-select>
          </div>
        </div>
        <div class="filter-item-box">
          <div class="label-box searchLabel">报错日期：</div>
          <div class="common-datepicker-box">
            <el-date-picker
              class="date-picker-primary"
              v-model="dateValue"
              type="daterange"
              size="mini"
              :clearable="false"
              popper-class="datepicker-popper-box"
              :editable="false"
              :append-to-body="false"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions" />
          </div>
          <div class="time-tab-box">
            <div
              :class="getTimeTabClassName('day')"
              @click="timeTabClick('day')">
              今天
            </div>
            <div
              :class="getTimeTabClassName('week')"
              @click="timeTabClick('week')">
              一周以内
            </div>
            <div
              :class="getTimeTabClassName('month')"
              @click="timeTabClick('month')">
              一月以内
            </div>
          </div>
        </div>
      </div>
      <div class="common-button-box">
        <el-button
          size="small"
          type="primary"
          class="primary-btn"
          @click="search">
          查询
        </el-button>
        <el-button
          size="small"
          @click="resetFilter"
          class="normal-btn"
          >重置</el-button
        >
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        ref="table"
        highlight-selection-row
        class="publish-table"
        :data="exceptionDataList"
        height="100%"
        :header-row-class-name="customHeader">
        <el-table-column
          label="序号"
          type="index"
          width="75" />
        <el-table-column
          label="ID"
          prop="id" />
        <el-table-column label="异常业务类型">
          <template v-slot="{ row }">
            <div class="text-overflow">
              {{ getEcxeptionBussinessName(row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="异常源类型">
          <template v-slot="{ row }">
            <div class="text-overflow">
              {{ getEcxeptionSourceName(row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="错误内容">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.exceptionMessage">
              {{ row.exceptionMessage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报错时间">
          <template v-slot="{ row }">
            <div>
              {{ row.exceptionTime ? formatTime(row.exceptionTime) : '--' }}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">没有找到相关内容</template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
    <div class="common-pagination-box">
      <el-pagination
        class="pagination-primary"
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="pageSize"
        :current-page="currPage"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import { getExceptionRecordService } from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      errorBusinessType: undefined,
      errorSourceType: undefined,
      dateValue: [],
      currTimeTab: 'day',
      pickerOptions: {
        disabledDate: date => {
          let currTime = new Date()
          let todayTime = new Date(currTime.toDateString()).getTime()
          let dateTime = date.getTime()

          return dateTime > todayTime
        },
        onPick: eventInfo => {
          let { maxDate, minDate } = eventInfo
          if (minDate && maxDate) {
            let deltaTime = maxDate.getTime() - minDate.getTime()
            if (deltaTime > 30 * 24 * 60 * 60 * 1000) {
              this.$message.warning('时间跨度不能超过一个月,请重新选择')
              this.$nextTick(() => {
                this.dateValue = []
              })
            }
            this.currTimeTab = ''
          }
        }
      },

      exceptionDataList: [],
      total: 0,
      currPage: 1,
      pageSize: 10,
      customHeader: ''
    }
  },
  mounted() {
    const currentBody = this.$refs.table.bodyWrapper
    currentBody.addEventListener('scroll', ev => {
      const scrollTop = ev.target.scrollTop
      this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
    })
    this.init()
  },
  methods: {
    init() {
      this.initDateValue()
      this.queryExceptionData().then(exceptionDataList => {
        this.exceptionDataList = exceptionDataList
      })
    },
    initDateValue() {
      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const beginTime = todayZeroHour.getTime() - 1000

      let startTime = new Date(beginTime)
      let endTime = new Date(beginTime + 24 * 60 * 60 * 1000)

      this.dateValue = [startTime, endTime]
    },
    timeTabClick(tabName) {
      this.currTimeTab = tabName

      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      let startTime = null
      let endTime = todayZeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      if (tabName === 'day') {
        startTime = new Date(endTime - 24 * 60 * 60 * 1000)
      }

      if (tabName === 'week') {
        startTime = new Date(endTime - 7 * 24 * 60 * 60 * 1000)
      }

      if (tabName === 'month') {
        startTime = new Date(endTime - 30 * 24 * 60 * 60 * 1000)
      }

      endTime = new Date(endTime)
      this.dateValue = [startTime, endTime]
    },
    getTimeTabClassName(tabName) {
      let className = 'tab-item-box'
      if (tabName === this.currTimeTab) {
        className += ' tab-active'
      }
      return className
    },
    search() {
      this.currPage = 1
      this.queryExceptionData().then(exceptionDataList => {
        this.exceptionDataList = exceptionDataList
      })
    },
    resetFilter() {
      this.keywords = ''
      this.errorBusinessType = undefined
      this.errorSourceType = undefined
      this.currTimeTab = 'day'
      this.initDateValue()
      this.currPage = 1
      this.queryExceptionData().then(exceptionDataList => {
        this.exceptionDataList = exceptionDataList
      })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.queryExceptionData().then(exceptionDataList => {
        this.exceptionDataList = exceptionDataList
      })
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.queryExceptionData().then(exceptionDataList => {
        this.exceptionDataList = exceptionDataList
      })
    },
    getEcxeptionBussinessName(exceptionInfo) {
      const dictionary = [
        { name: '文件上传异常', value: 'Upload' },
        { name: '下载异常', value: 'Download' },
        { name: '转换异常', value: 'Convert' },
        { name: '商业化授权异常', value: 'Commercialize' },
        { name: '初始化异常', value: 'SysInitialize' },
        { name: '其他异常', value: 'Other' }
      ]

      let find = dictionary.find(el => el.value === exceptionInfo.bussinessType)
      if (find) {
        return find.name
      } else {
        return '--'
      }
    },
    getEcxeptionSourceName(exceptionInfo) {
      const dictionary = [
        { name: '配置错误', value: 'InvalidConfigenation' },
        { name: '参数错误', value: 'InvalidParameter' },
        { name: '商业化授权错误', value: 'InvalidCommercialize' },
        { name: '操作错误', value: 'InvalidOperation' },
        { name: '权限错误', value: 'InvalidAuthorization' },
        { name: '数据库错误', value: 'DbError' },
        { name: '其他异常', value: 'Other' }
      ]

      let find = dictionary.find(el => el.value === exceptionInfo.sourceType)
      if (find) {
        return find.name
      } else {
        return '--'
      }
    },
    queryExceptionData() {
      return new Promise(resolve => {
        let params = {
          // prettier-ignore
          businessType: this.errorBusinessType ? this.errorBusinessType : undefined,
          sourceType: this.errorSourceType ? this.errorSourceType : undefined,
          exceptionMessage: this.keywords,
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        if (this.dateValue.length) {
          params.startTime = this.formatDate(this.dateValue[0])
          params.endTime = this.formatDate(this.dateValue[1])
        }
        getExceptionRecordService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let exceptionDataList = data.items
            this.total = data.totalCount
            resolve(exceptionDataList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatDate(dateTime) {
      // prettier-ignore
      const zeroHour = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

      let formatDateTime = zeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      formatDateTime = formatTime(new Date(formatDateTime))
      return formatDateTime
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.exception-logs-box {
  height: 100%;

  .title-box {
    display: flex;
    align-items: center;

    .symbol {
      width: 4px;
      height: 20px;
      background: var(--base-primary-bgColor);
    }

    .title {
      margin-left: 10px;
      color: var(--page-title-color);
    }
  }

  .operation-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0;
    .filter-box {
      display: flex;
      flex-wrap: wrap;

      .filter-item-box {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .label-box {
          flex-shrink: 0;
        }

        .common-select-box {
          text-align: left;
        }

        .common-datepicker-box {
          width: 240px;

          .el-date-editor {
            width: 100%;
            :deep(.el-range-input) {
              font-size: 14px;
              font-weight: 400;
            }
          }
        }

        .time-tab-box {
          display: flex;
          margin-left: 15px;

          .tab-item-box {
            margin-right: 10px;
            padding: 5px 10px;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
            border: 1px solid var(--api-search-time-border-color);
            background-color: var(--api-search-time-bgColor);
            color: var(--api-search-time-text-color);

            &:hover {
              color: var(--base-primary-bgColor);
              border-color: var(--base-primary-bgColor);
            }
          }

          .tab-active {
            color: var(--base-primary-bgColor);
            border-color: var(--base-primary-bgColor);
            background-color: var(--base-bg-light-color24);
          }
        }
      }
    }

    .common-button-box {
      display: flex;
      margin-left: auto;
    }
  }

  .common-table-box {
    height: calc(100% - 167px);
    padding: 0 16px;
  }
}
</style>
